// Componente para Google Analytics
export const trackEvent = (action, category, label, value) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value
    });
  }
};

export const trackPageView = (page_title, page_location) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', 'G-Y7T13RMJJX', {
      page_title: page_title,
      page_location: page_location
    });
  }
};

export const trackFormSubmission = (formName) => {
  trackEvent('form_submit', 'engagement', formName);
};

export const trackButtonClick = (buttonName, location) => {
  trackEvent('button_click', 'engagement', buttonName, location);
};

export const trackPhoneCall = (phoneNumber) => {
  trackEvent('phone_call', 'engagement', phoneNumber);
};

export const trackEmailClick = (emailAddress) => {
  trackEvent('email_click', 'engagement', emailAddress);
};

export const trackVideoPlay = (videoName) => {
  trackEvent('video_play', 'engagement', videoName);
};

export const trackScroll = (section) => {
  trackEvent('scroll', 'engagement', section);
};

export const trackThemeToggle = (theme) => {
  trackEvent('theme_toggle', 'engagement', theme);
};

export const trackNavigation = (pageName) => {
  trackEvent('navigation', 'engagement', pageName);
};

export const trackContactMethod = (method) => {
  trackEvent('contact_method', 'engagement', method);
};

export const trackServiceInterest = (service) => {
  trackEvent('service_interest', 'engagement', service);
};

export const trackDownload = (fileName) => {
  trackEvent('download', 'engagement', fileName);
};

export const trackSocialShare = (platform, content) => {
  trackEvent('social_share', 'engagement', `${platform}_${content}`);
};

export const trackError = (errorType, errorMessage) => {
  trackEvent('error', 'error', errorType, errorMessage);
};

export const trackPerformance = (metric, value) => {
  trackEvent('performance', 'performance', metric, value);
};

export const trackSnakeGameStart = () => {
  trackEvent('snake_game_start', 'home_snake', 'begin_round', undefined);
};

export const trackSnakeGameOver = (score) => {
  const v = typeof score === 'number' && !Number.isNaN(score) ? Math.round(score) : undefined;
  trackEvent('snake_game_over', 'home_snake', 'round_end', v);
};

// Hook personalizado para tracking
export const useAnalytics = () => {
  return {
    trackEvent,
    trackPageView,
    trackFormSubmission,
    trackButtonClick,
    trackPhoneCall,
    trackEmailClick,
    trackVideoPlay,
    trackScroll,
    trackThemeToggle,
    trackNavigation,
    trackContactMethod,
    trackServiceInterest,
    trackDownload,
    trackSocialShare,
    trackError,
    trackPerformance,
    trackSnakeGameStart,
    trackSnakeGameOver
  };
};

export default useAnalytics; 